import type { SVGProps } from 'react'

type IconName =
  | 'cove'
  | 'focus'
  | 'collection'
  | 'progress'
  | 'settings'
  | 'play'
  | 'pause'
  | 'close'
  | 'feed'
  | 'ticket'
  | 'tasks'
  | 'sparkle'
  | 'check'

const paths: Record<IconName, string> = {
  cove: 'M3 15c3-3 6-4 9-2s6 1 9-2v8H3v-4Zm3-5c0-3 2-5 4-6 1 3 0 5-1 7m6 0c0-3 1-5 4-7 1 3 0 6-2 8',
  focus: 'M12 3a9 9 0 1 0 9 9M12 7v5l3 2m2-11h4v4',
  collection: 'M4 5h16v14H4zM8 5V3h8v2M8 10h8m-8 4h5',
  progress: 'M4 19V9m5 10V5m5 14v-7m5 7V3',
  settings: 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm8 4 2-1-2-4-2 1-2-1-1-3H9L8 7 6 8 4 7l-2 4 2 1v2l-2 1 2 4 2-1 2 1 1 3h4l1-3 2-1 2 1 2-4-2-1v-2Z',
  play: 'm8 5 11 7-11 7V5Z',
  pause: 'M7 5h4v14H7zm7 0h4v14h-4z',
  close: 'm6 6 12 12M18 6 6 18',
  feed: 'M6 14c-2-2-1-6 2-7 4-1 7 3 6 7-1 4-6 6-8 2Zm8-7c1-3 4-4 6-3 0 3-2 5-6 5',
  ticket: 'M4 7a2 2 0 0 0 0 4v6h16v-6a2 2 0 0 0 0-4V7H4Zm8 2v6',
  tasks: 'M9 6h11M9 12h11M9 18h11M4 6l1 1 2-2m-3 7 1 1 2-2m-3 7 1 1 2-2',
  sparkle: 'm12 3 1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Zm7 13 .7 2.3L22 19l-2.3.7L19 22l-.7-2.3L16 19l2.3-.7L19 16Z',
  check: 'm5 12 4 4L19 6',
}

export function Icon({ name, ...props }: { name: IconName } & SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d={paths[name]} />
    </svg>
  )
}
